/* eslint-disable max-len */
/* eslint-disable no-restricted-globals */
import React, { useCallback, useEffect, useRef, useState } from 'react'
import './App.css';
import { AnimatePresence, motion } from 'framer-motion';
import 'tw-elements';
import './index.css';
import { useDispatch, useSelector } from 'react-redux'
import GlobalContext from './components/Context/GloablContext';
import Toast from './components/Toast';
import NavigationRoutes from './routes';
import { handleSystemConfig } from './redux/systemConfigSlice'
import { dataService } from './services/data.services';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAddNotesMutation } from './slices/patientSlice';
import refreshIdToken from './CommonMethods/RefreshIdFunction';
import { websocketURL } from '../src/config/index'
import { handleEditMessageSent, handleTargetUserEditId } from './redux/systemConfigSlice'
import { userService } from './services/user.services';
import { resetDashboardSearch } from './redux/dashboardSearchSlice';
import { resetAlertNotificationSearch } from './redux/alerAndNotificationSearchSlice';
import { resetDeviceAlertDashboardSearch } from './redux/deviceAleartDashboardSlice';
import { resetDeviceAlertSearch } from './redux/deviceAlertReportSearchSlice';
import { resetPatientSearch } from './redux/patientSearchSlice';
import { fetchImageAsBlob, getPDFImage, storePDFImage } from './components/HelpGuideModal/indexDB';
import { 
    syncSessionFromLocalStorage, 
    getAuthItem, 
    clearAuthSession,
    hasValidSession,
    subscribeToAuthEvents,
    broadcastLogout,
    broadcastForcedLogout
} from './CommonMethods/authSession';
import { CheckUserStatus } from './CommonMethods/CheckUserStatus';
import { logIn, logout, setUserType } from './pages/auth/authSlice';
// import { fetchFeatureFlags } from  './CommonMethods/AppConfig';
import { AwsRum } from 'aws-rum-web';
if (process.env.REACT_APP_STAGE === 'prod') {
    try {
        const config = {
            sessionSampleRate: 1 ,
            identityPoolId: "us-east-1:51df4d82-30d8-400b-ac0a-e2e5d2b447ce" ,
            endpoint: "https://dataplane.rum.us-east-1.amazonaws.com" ,
            telemetries: ["performance","errors","http"] ,
            allowCookies: true ,
            enableXRay: false ,
            signing: true // If you have a public resource policy and wish to send unsigned requests please set this to false
        };

        const APPLICATION_ID = '21ab96d8-669c-4fbb-b1b4-1f738913d7b0';
        const APPLICATION_VERSION = '1.0.0';
        const APPLICATION_REGION = 'us-east-1';

        const awsRum = new AwsRum(
            APPLICATION_ID,
            APPLICATION_VERSION,
            APPLICATION_REGION,
            config
        );console.log("aws rum")
    } catch (error) {
        // Ignore errors thrown during CloudWatch RUM web client initialization
    }
}
function App(props) {
    const { id } = useParams()
    const editingUserIdRef = useRef('');
    const dispatch = useDispatch()
    const navigationPath = NavigationRoutes(props)
    const [Toastmessage, setToastmessage] = useState('');
    const [toastErrorMessage, setToastErrorMessage] = useState('')
    const [ToastWarnmessage, setToastWarnmessage] = useState('')
    const [isSideBar, setIsSideBar] = useState(false);
    const [restrictKey, setRestrictKey] = useState(false);
    const [UpdateCall, setUpdateCall] = useState(false)
    const [systemConfigDateformat, setSystemConfigDateformat] = useState('')
    const [editSocket, setEditSocket] = useState(false)
    const [getData, setGetData] = useState()
    // time related states'
    const [addNotes] = useAddNotesMutation()
    const [wellnessNotes, setWellnessNotes] = useState('')
    const [patientIdfromGlobal, setPatientIdFromGlobal] = useState('');
    const [isTimerStarted, setIsTimerStarted] = useState(false);
    const [sumbitButtonClicked, setSubmitButtonClicked] = useState(false)
    const [emptyWellness, setEmptyWellness] = useState(false)
    const [isOpen, setIsOpen] = useState(true)
    const [userEditId, setUserEditId] = useState('')
    const [isSearchOpen, setIsSearchOpen] = useState(false)
    const editingUserId = useSelector(state => state?.systemConfigData?.editingUserId)
    const [isSessionInitialized, setIsSessionInitialized] = useState(false)
    const isLoggingOutRef = useRef(false);
    // Expose logout flag globally for logout handlers
    window.isLoggingOutRef = isLoggingOutRef;

    const [currentTime, setCurrentTime] = useState(0);
    const intervalRef = useRef();
    const navigate = useNavigate();
    const location = useLocation();

    const [seconds, setSeconds] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [hours, setHours] = useState(0);

    useEffect(() => {
        const sec = Math.floor(currentTime / 1000);
        const min = Math.floor(sec / 60);
        const hour = Math.floor(min / 60);

        setSeconds(sec % 60);
        setMinutes(min % 60);
        setHours(hour % 24);
    }, [currentTime]);

    // Update timer display based on stored start time
    useEffect(() => {
        if (isTimerStarted) {
            const updateTimer = () => {
                const startTime = localStorage.getItem('timerStartTime');
                if (startTime) {
                    const elapsed = Date.now() - parseInt(startTime);
                    setCurrentTime(elapsed);
                }
            };

            intervalRef.current = setInterval(updateTimer, 100);
            return () => clearInterval(intervalRef.current);
        }
    }, [isTimerStarted]);

    // Check for existing timer on component mount
    useEffect(() => {
        const startTime = localStorage.getItem('timerStartTime');
        const timerActive = localStorage.getItem('timerActive');

        if (startTime && timerActive === 'true') {
            setIsTimerStarted(true);
            const elapsed = Date.now() - parseInt(startTime);
            setCurrentTime(elapsed);
        }
    }, []);

    const startTimer = () => {
        const startTime = Date.now();
        localStorage.setItem('timerStartTime', startTime.toString());
        localStorage.setItem('timerActive', 'true');
        setIsTimerStarted(true);
        setCurrentTime(0);
    };

    const resetTimer = () => {
        localStorage.removeItem('timerStartTime');
        localStorage.removeItem('timerActive');
        clearInterval(intervalRef.current);
        setCurrentTime(0);
        setSeconds(0);
        setMinutes(0);
        setHours(0);
        setIsTimerStarted(false);
    };

    const stopTimer = async () => {

        if (wellnessNotes === '') {
            setEmptyWellness(true)
            setToastErrorMessage("Please fill in all the mandatory fields");
            return
        } else {
            setEmptyWellness(false)
            setSubmitButtonClicked(true)
            const endTime = `(${hours} Hrs:${minutes} Mins:${seconds} Secs)`;
            const body = {
                "patient_id": patientIdfromGlobal,
                "note_type": "wellness-note",
                "end_time": endTime,
                "description": wellnessNotes
            }
            clearInterval(intervalRef.current); // Stop the timer
            
            setIsTimerStarted(false); // Set the timer started flag to false
            const response = await addNotes(body)
            if (response) {
                if (response?.error?.status === 401) {
                    setToastErrorMessage(response.error.data)
                    return
                } else {
                    setToastmessage(response?.data.message)
                    setSubmitButtonClicked(false)
                    setWellnessNotes(''); // Clear wellnessNotes
                    // Clear timer data from localStorage
                    localStorage.removeItem('timerStartTime');
                    localStorage.removeItem('timerActive');
                    setCurrentTime(0)
                    clearInterval(intervalRef.current); // Stop the timer
                    setSeconds(0); // Reset seconds
                    setMinutes(0); // Reset minutes
                    setHours(0); // Reset hours
                    setIsTimerStarted(false); // Set the timer started flag to false
                }
            } else {
                setToastErrorMessage(response?.data.message)
                clearInterval(intervalRef.current); // Stop the timer
                setSubmitButtonClicked(false)
            }
        }
    };

    // Only clear wellness notes when navigating away from contact history, but keep timer running
    useEffect(() => {
        if (location.pathname === `/manage-patients/view-patient/${location.pathname.split('/').slice(-1)[0]}`) {
            setEmptyWellness(false)
        }
        // Timer should continue running in background - only clear on explicit stop
    }, [location.pathname]);

    // Cleanup on component unmount
    useEffect(() => {
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, []);

    const [globalVariables, setGlobalVariables] = useState({
        "date_format": "",
        "country_code": "",
        "max_file_size": "",
        "email_addr": "",
        "session_timeout": "",
        "public_encryp_key": "",
        "browser_trust_duration": "",
        "temp_pass_duration": "",
        "recent_otp_durn": "",
        "max_failed_attempts": "",
        "otp_validity_durn": ""
    })

    const [vitalInfo, setVitalInfo] = useState({
        "blood_glucose": " ",
        "blood_pressure": " ",
        "temperature": " ",
        "SP02": " ",
        "pulse": " ",
        "weight": " ",
        "height": " "
    })

    const sendMessageToStartEditing = (data, isReconnect, ws) => {
        const startEditingAction = { action: 'startEditing', target: data === '' ? editingUserId : data, user: sessionStorage.getItem('email') };
        if (isReconnect !== undefined && isReconnect === 'reconnect') {
            ws.send(JSON.stringify(startEditingAction))
            setUserEditId(data)
            dispatch(handleEditMessageSent(true))
        } else if (editSocket && (editSocket?.readyState === 0 || editSocket?.readyState === 1)) {
            editSocket.send(JSON.stringify(startEditingAction));
            setUserEditId(data)
            dispatch(handleEditMessageSent(true))
        } else if (editSocket?.readyState === 3) {
            console.error('WebSocket connection is not open');
            WebSocketConnection('start', data)
        }
    };

    const sendMessageToStopEditing = (data) => {
        const stopEditingAction = { action: 'stopEditing', target: userEditId === '' ? ((data === undefined || data === '') ? editingUserId : data) : userEditId };
        if ((!editSocket || editSocket?.readyState !== 1) && window?.websocket?.readyState === 1 && (stopEditingAction?.target !== '' && stopEditingAction?.target !== undefined) && (userEditId !== '' || userEditId !== undefined)) {
            window?.websocket?.send(JSON.stringify(stopEditingAction))
            dispatch(handleEditMessageSent(false))
            dispatch(handleTargetUserEditId(''))
        }
        else if (editSocket && (editSocket?.readyState === 0 || editSocket?.readyState === 1) && (userEditId !== '' || userEditId !== undefined || data !== undefined)) {
            editSocket?.send(JSON.stringify(stopEditingAction));
            dispatch(handleEditMessageSent(false))
            dispatch(handleTargetUserEditId(''))
        } else if (editSocket?.readyState === 3) {
            console.error('WebSocket connection is not open');
            //WebSocketConnection('stop',userEditId===''?data:userEditId)
        }
    }

    const WebSocketConnection = (startOrStop, targetId) => {
        // Close existing WebSocket connections before creating new one
        if (editSocket && (editSocket.readyState === 0 || editSocket.readyState === 1)) {
            editSocket.onmessage = null; // Remove old message handler
            editSocket.onclose = null; // Prevent reconnection
            editSocket.close();
        }
        if (window.websocket && (window.websocket.readyState === 0 || window.websocket.readyState === 1)) {
            window.websocket.onmessage = null; // Remove old message handler
            window.websocket.onclose = null; // Prevent reconnection
            window.websocket.close();
        }
        
        // Don't create new connection if logging out
        if (isLoggingOutRef.current) {
            return;
        }
        
        // fetchFeatureFlags()
        dispatch(handleEditMessageSent(false))
        const ws = new WebSocket(`${websocketURL}?user=${encodeURIComponent(sessionStorage?.getItem('email'))}`);
        window.websocket = ws
        ws.onopen = () => {
            setEditSocket(ws)
            if (startOrStop !== undefined && startOrStop === 'start') {
                sendMessageToStartEditing(targetId === '' ? editingUserId : targetId, 'reconnect', ws)
                //addpersist logic here to get target userid nd send message
            } else if (startOrStop !== undefined && startOrStop === 'stop') {
                sendMessageToStopEditing(targetId === '' ? editingUserId : targetId)
            }
            // You can add further logic here, like informing the server about the edit screen access.
        };
        ws.onclose = (event) => {
            // Don't reconnect if logging out or if session is invalid
            if (isLoggingOutRef.current || !sessionStorage.getItem('IdToken')) {
                return;
            }
            
            const editRoutes = ['/manage-patients/edit-patient/:id']
            const editedUserId = editingUserIdRef.current;
            editedUserId !== '' ? WebSocketConnection('start', editedUserId) : WebSocketConnection();
        }
        ws.onerror = (error) => {
            console.error('WebSocket error:', error);
            // Attempt to reconnect after a delay
            setTimeout(WebSocketConnection, 3000); // 3 seconds delay, adjust as needed
        };
    }

    const fetchSystemConfigData = async () => {
        // setLoading(true )
        let response
        response = await dataService.systemConfigDataFromAdmin();
        if (response.error === false) {
            setGetData(response.data.data)
            dispatch(handleSystemConfig(response.data))
            const Getdata = response.data
            setSystemConfigDateformat((prev) => ({
                ...prev,
                "date_format": response?.data?.global_variables.date_format,
                "blood_glucose": response?.data?.vital_information?.blood_glucose,
                "blood_pressure": response?.data?.vital_information?.blood_pressure,
                "temperature": response?.data?.vital_information?.temperature,
                "SP02": response?.data?.vital_information?.SP02,
                "pulse": response?.data?.vital_information?.pulse,
                "weight": response?.data?.vital_information?.weight,
                "height": response?.data?.vital_information?.height,
            }))
            setGlobalVariables((prev) => ({
                ...prev,
                "date_format": Getdata?.global_variables?.date_format,
                "country_code": Getdata?.global_variables?.country_code,
                "max_file_size": Getdata?.global_variables?.maximum_file_size,
                "email_addr": Getdata?.global_variables?.email_address,
                "session_timeout": Getdata?.global_variables?.session_timeout,
                "public_encryp_key": Getdata?.global_variables?.public_encryption_key,
                "browser_trust_duration": Getdata?.global_variables?.browser_trust_duration,
                "temp_pass_duration": Getdata?.global_variables?.temporary_password_expiry_duration,
                "recent_otp_durn": Getdata?.global_variables?.resend_otp_duration,
                "max_failed_attempts": Getdata?.global_variables?.max_failed_login_attempts,
                "otp_validity_durn": Getdata?.global_variables?.otp_validity_duration
            }))
            setVitalInfo((prev) => ({
                ...prev,
                "blood_glucose": Getdata?.vital_information?.blood_glucose,
                "blood_pressure": Getdata?.vital_information?.blood_pressure,
                "temperature": Getdata?.vital_information?.temperature,
                "SP02": Getdata?.vital_information?.SP02,
                "pulse": Getdata?.vital_information?.pulse,
                "weight": Getdata?.vital_information?.weight,
                "height": Getdata?.vital_information?.height,

            }))
        }
    }

    // Define the handleRefreshToken function
    const handleRefreshToken = async () => {
        if (sessionStorage.getItem('IdToken')) {
            refreshIdToken()
        }
    };

    const initializeSession = useCallback(async () => {
        try {
            // Duplicated tabs inherit sessionStorage with staged tokens and the pending flag.
            // They are not authenticated — skip session init entirely to prevent unnecessary
            // API calls, incorrect Redux state, and WebSocket connections with staged tokens.
            if (sessionStorage.getItem('duplicate_session_pending') === 'true') {
                dispatch(logout());
                setIsSessionInitialized(true);
                return;
            }

            syncSessionFromLocalStorage();

            if (!hasValidSession()) {
                // Preserve any pending toast flag — dispatch(logout()) calls sessionStorage.clear()
                // which would wipe it before SignIn's useEffect can read it.
                const pendingDuplicateLogout = sessionStorage.getItem('showDuplicateSessionLogout');
                dispatch(logout());
                if (pendingDuplicateLogout) {
                    sessionStorage.setItem('showDuplicateSessionLogout', pendingDuplicateLogout);
                }
                setIsSessionInitialized(true);
                return;
            }

            const userStatus = await CheckUserStatus();
            
            if (!userStatus) {
                clearAuthSession();
                dispatch(logout());
                setIsSessionInitialized(true);
                return;
            }

            const userType = getAuthItem('user_type');
            const email = getAuthItem('email') || '';
            
            if (userType) {
                dispatch(setUserType(userType));
            }
            dispatch(logIn(email));
            
            // Reset logout flag on successful login
            isLoggingOutRef.current = false;

            if (sessionStorage.getItem('IdToken')) {
                refreshIdToken();
                WebSocketConnection();
            }

            setIsSessionInitialized(true);
        } catch (error) {
            if (error.response?.status === 401 || error.response?.status === 403) {
                clearAuthSession();
                dispatch(logout());
            } else {
                dispatch(logout());
            }
            setIsSessionInitialized(true);
        }
    }, [dispatch]);

    useEffect(() => {
        initializeSession();
    }, [initializeSession]);

    useEffect(() => {
        // Check for password update success toast on mount
        const passwordUpdateToast = localStorage.getItem('passwordUpdateSuccessToast');
        if (passwordUpdateToast) {
            setToastmessage(passwordUpdateToast);
            localStorage.removeItem('passwordUpdateSuccessToast');
        }
        
        const unsubscribe = subscribeToAuthEvents((eventType, broadcastTimestamp) => {
            if (eventType === 'logout') {
                // This tab has a pending duplicate session decision — it was never fully authenticated.
                // The logout broadcast is not meant for this tab; ignore it to prevent a misleading toast.
                const duplicateSessionPending = sessionStorage.getItem('duplicate_session_pending') === 'true';
                // Storage events ONLY fire in OTHER tabs per spec, but check localLogoutInProgress
                // to handle potential browser-specific edge cases where the event might fire locally
                const isLocalLogout = localStorage.getItem('localLogoutInProgress') === 'true';
                const isPasswordUpdateLogout = localStorage.getItem('passwordUpdateLogout') === 'true';
                const passwordUpdateToast = localStorage.getItem('passwordUpdateSuccessToast');
                if (duplicateSessionPending) {
                    return;
                }

                // Close WebSocket immediately to prevent race condition.
                // Storage event fires before WS "logout" message arrives from server.
                // Without closing here, WS stays open → isUserConnected returns true → isLoggedIn modal.
                if (window.websocket && (window.websocket.readyState === 0 || window.websocket.readyState === 1)) {
                    window.websocket.onmessage = null;
                    window.websocket.onclose = null;
                    window.websocket.close();
                }

                const browserIdValue = localStorage.getItem('arcm_trust_browser_token');
                const LogoutfromAllTabs = localStorage.getItem('LogoutfromAllTabs');
                
                clearAuthSession();
                
                if (browserIdValue) {
                    localStorage.setItem('arcm_trust_browser_token', browserIdValue);
                }
                if (LogoutfromAllTabs) {
                    localStorage.setItem('LogoutfromAllTabs', LogoutfromAllTabs);
                }
                
                dispatch(logout());
                
                // Set flag for SignIn component to display toast (only if not local or password update)
                // NOTE: `storage` events are delivered to OTHER tabs; suppressing the toast based on
                // `localLogoutInProgress` causes the flag to be globally true and hides the toast.
                // We only suppress for password-update logout to preserve intended behavior.
                if (!isPasswordUpdateLogout) {
                    localStorage.setItem('showLogoutToast', 'true');
                } else if (passwordUpdateToast) {
                    setToastmessage(passwordUpdateToast);
                    localStorage.removeItem('passwordUpdateSuccessToast');
                }
                localStorage.removeItem('passwordUpdateLogout');
                
                navigate('/');
            } else if (eventType === 'forced_logout') {
                // Another tab was WS-force-logged out (duplicate session from a different device).
                // Skip if this tab is the new-login tab (in modal or awaiting DuplicateTabClose API).
                if (sessionStorage.getItem('duplicate_session_pending') === 'true' ||
                    sessionStorage.getItem('duplicateTabCloseInProgress') === 'true') {
                    return;
                }
                clearAuthSession();
                dispatch(logout());
                // Set AFTER dispatch(logout()) because that calls sessionStorage.clear().
                sessionStorage.setItem('showDuplicateSessionLogout', 'true');
                navigate('/');
            } else if (eventType === 'login') {
                // If this tab is still showing the duplicate session modal, the session
                // has been resolved by another tab — clear the pending flag and reload.
                if (sessionStorage.getItem('duplicate_session_pending') === 'true') {
                    sessionStorage.removeItem('duplicate_session_pending');
                    window.location.reload();
                    return;
                }
                syncSessionFromLocalStorage();
                initializeSession();
            } else if (eventType === 'session_confirmed') {
                // Another tab confirmed the duplicate session modal and is proceeding through OTP.
                // Dismiss this tab's stale modal immediately without waiting for OTP to complete.
                if (sessionStorage.getItem('duplicate_session_pending') === 'true') {
                    sessionStorage.removeItem('duplicate_session_pending');
                    window.location.reload();
                }
            }
        });

        return unsubscribe;
    }, [navigate, initializeSession, dispatch]);

    useEffect(() => {
        const intervalId = setInterval(handleRefreshToken, 9 * 60 * 1000);
        if (sessionStorage.getItem('IdToken') && sessionStorage.getItem('duplicate_session_pending') !== 'true') {
            refreshIdToken()
            WebSocketConnection()
        }
        fetchSystemConfigData()
    }, [])

    useEffect(() => {
        editingUserIdRef.current = editingUserId;
    }, [editingUserId])

    const handleClear = () => {
        if ((Toastmessage && Toastmessage !== '') || (toastErrorMessage && toastErrorMessage !== '')) {
            setToastmessage('');
            setToastErrorMessage();
        }
    }

    const handleOnClickClearSearch = () => {
        setIsSearchOpen(false)
        dispatch(resetDashboardSearch());
        dispatch(resetAlertNotificationSearch())
        dispatch(resetDeviceAlertDashboardSearch())
        dispatch(resetDeviceAlertSearch())
        dispatch(resetPatientSearch())
    }

    useEffect(() => {
        let hasLoggedOut = false;
        if (editSocket && !hasLoggedOut) {
            // Remove any existing message handler first
            editSocket.onmessage = null;
            
            editSocket.onmessage = async (event) => {
                // Ignore messages if already logged out or logging out
                if (hasLoggedOut || isLoggingOutRef.current) {
                    return;
                }
                
                const message = event.data;
                
                if (message === "logout") {
                    const isPasswordUpdateLogout = localStorage.getItem('passwordUpdateLogout') === 'true';
                    hasLoggedOut = true;
                    isLoggingOutRef.current = true;
                    
                    // Close WebSocket connections immediately
                    if (editSocket && (editSocket.readyState === 0 || editSocket.readyState === 1)) {
                        editSocket.onmessage = null;
                        editSocket.onclose = null;
                        editSocket.close();
                    }
                    if (window.websocket && (window.websocket.readyState === 0 || window.websocket.readyState === 1)) {
                        window.websocket.onmessage = null;
                        window.websocket.onclose = null;
                        window.websocket.close();
                    }

                    const browserIdValue = localStorage.getItem('arcm_trust_browser_token');
                    const LogoutfromAllTabs = localStorage.getItem('LogoutfromAllTabs');
                    
                    clearAuthSession();
                    // Use broadcastForcedLogout so sibling old-session tabs show
                    // "another login session" toast instead of "logout in another tab".
                    broadcastForcedLogout();

                    if (browserIdValue) {
                        localStorage.setItem('arcm_trust_browser_token', browserIdValue);
                    }
                    if (LogoutfromAllTabs) {
                        localStorage.setItem('LogoutfromAllTabs', LogoutfromAllTabs);
                    }

                    dispatch(logout());
                    
                    // WebSocket logout messages come from server, so this tab didn't initiate it
                    // Set flag for SignIn component to display toast (only if not password update)
                    if (!isPasswordUpdateLogout) {
                        sessionStorage.setItem('showDuplicateSessionLogout', 'true');
                        window.location.reload();
                        return;
                    }

                    const passwordUpdateToast = localStorage.getItem('passwordUpdateSuccessToast');
                    if (passwordUpdateToast) {
                        setToastmessage(passwordUpdateToast);
                        localStorage.removeItem('passwordUpdateSuccessToast');
                    }
                    localStorage.removeItem('passwordUpdateLogout');
                    navigate('/', { replace: true });
                    return;
                }
            };
        }
        
        // Cleanup: remove message handler when editSocket changes or component unmounts
        return () => {
            if (editSocket && editSocket.onmessage) {
                editSocket.onmessage = null;
            }
        };
    }, [editSocket, dispatch, navigate, setToastmessage])

    const fetchAndCacheHelpGuides = async () => {
        try {
            const apiResponse = await dataService.GetAPI('users/help-guides?getAllFiles=true');
            const files = apiResponse?.data?.data?.files || {};

            for (const [fileName, fileUrl] of Object.entries(files)) {
                const pageKey = `${fileName}_page_1`;

                const cachedImage = await getPDFImage(pageKey);
                if (cachedImage) {
                    continue; // Skip if already cached
                }

                const imgBlob = await fetchImageAsBlob(fileUrl);
                if (imgBlob) {
                    await storePDFImage(pageKey, imgBlob);
                }
            }
        } catch (error) {
            console.error("Error fetching help guides:", error);
        }
    };

    return (
        <GlobalContext.Provider value={{
            editSocket,
            WebSocketConnection,
            setEditSocket,
            sendMessageToStartEditing,
            sendMessageToStopEditing,
            setToastmessage,
            Toastmessage,
            isSideBar,
            setIsSideBar,
            setToastErrorMessage,
            toastErrorMessage,
            UpdateCall,
            setUpdateCall,
            setToastWarnmessage,
            setRestrictKey,
            restrictKey,
            systemConfigDateformat,
            currentTime,
            startTimer,
            stopTimer,
            resetTimer,
            wellnessNotes,
            setWellnessNotes,
            setPatientIdFromGlobal,
            patientIdfromGlobal,
            currentTime,
            hours,
            minutes,
            seconds,
            isTimerStarted,
            sumbitButtonClicked,
            emptyWellness,
            setEmptyWellness,
            isOpen,
            setIsOpen,
            isSearchOpen,
            setIsSearchOpen,
            handleOnClickClearSearch,
            fetchAndCacheHelpGuides
        }}>
            <AnimatePresence>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    onClick={() => handleClear()}
                    transition={{ duration: 1 }}
                >
                    {navigationPath}
                    {Toastmessage !== '' && Toastmessage !== undefined && <Toast
                        message={Toastmessage}
                        type="success"
                        setToastmessage={setToastmessage} />}
                    {toastErrorMessage !== '' && toastErrorMessage !== undefined && <Toast
                        message={toastErrorMessage}
                        type="error"
                        setToastmessage={setToastErrorMessage} />}
                    {ToastWarnmessage !== '' && ToastWarnmessage !== undefined && <Toast
                        message={ToastWarnmessage}
                        type="warn"
                        setToastmessage={setToastWarnmessage} />}
                </motion.div>
            </AnimatePresence>
        </GlobalContext.Provider>
    );
}

export default App;
